<template>
  <div class="home">
    <b-container class="homeContainer">
        <b-row>
          <b-col lg='12' md='12' cols='12' class="mobileWidth">
              <div class="homeReport-list HomehomeReport-list homeHeight" :style="{height: NewWidgetHeight, 'min-height' : NewMinheight, 'max-height' : NewMaxheight }" :class="{mobWidgetPad: mobWidget == 'Y'}">
                <template>
                  <b-tabs content-class="test" >
                    <template >
                      <b-tab title="This Week" id="onetab" title-item-class="tabsStyle tabone" active >
                        <b-tabs content-class="mt-3">
                            <b-tab :title="wpgaTournName" active title-item-class="widthSpace" @click="say('WPGATab')">
                                <WPGAHome 
                                    :config="config" 
                                    :WPGACode="WPGACode" 
                                    :reports="Wpgareports"
                                    :season="season"
                                    :tm_params="tm_params"
                                    :playsus="playsus" 
                                />
                            </b-tab>
                            <b-tab :title="ausTournName" title-item-class="widthSpace" @click="say('AusTab')">
                                <AusHome 
                                    :config="config" 
                                    :AusCode="AusCode" 
                                    :reports="Ausreports"
                                    :season="season"
                                    :tm_params="tm_params"
                                    :playsus="playsus"
                                />
                            </b-tab>
                            <!-- <b-tab :title="ausTournName" active title-item-class="widthSpace" @click="say('AusTab')">
                                <AusHome 
                                    :config="config" 
                                    :AusCode="AusCode" 
                                    :reports="Ausreports"
                                    :season="season"
                                    :tm_params="tm_params"
                                    :playsus="playsus"
                                />
                            </b-tab>
                            <b-tab :title="wpgaTournName" title-item-class="widthSpace" @click="say('WPGATab')">
                                <WPGAHome 
                                    :config="config" 
                                    :WPGACode="WPGACode" 
                                    :reports="Wpgareports"
                                    :season="season"
                                    :tm_params="tm_params"
                                    :playsus="playsus" 
                                />
                            </b-tab> -->
                        </b-tabs>
                      </b-tab>
                    </template>
                    <b-tab title="Upcoming" title-item-class="tabsStyle tabtwo" classActive>
                      <UpcomingReportSelect :season="season" />
                    </b-tab>
                    <b-tab title="Results" title-item-class="tabsStyle tabthree">
                      <ResultsReportSelect :season="season"/>
                    </b-tab>
                  </b-tabs>
                </template>
              </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="colClass">
              <div class="RolexSection">
                <!-- <template v-if="MessageTour == 'WPGATab'">
                  <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + season + '&name=' + WPGAnamecourse + '&timediff=' + WPGAtimediff + '&code=' + WPGAcodeRolex + '&until=' + WPGAuntil + '&tour=wpg'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
                </template>
                <template v-else>
                  <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + season + '&name=' + namecourse + '&timediff=' + timediff + '&code=' + codeRolex + '&until=' + until + '&tour=aus'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
                </template> -->
                <template v-if="MessageTour == 'AusTab'">
                  <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + season + '&name=' + namecourse + '&timediff=' + timediff + '&code=' + codeRolex + '&until=' + until + '&tour=aus'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
                </template>
                <template v-else>
                  <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + season + '&name=' + WPGAnamecourse + '&timediff=' + WPGAtimediff + '&code=' + WPGAcodeRolex + '&until=' + WPGAuntil + '&tour=wpg'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
                </template>
              </div>
              <!-- WPGATab -->
              <!-- AusTab -->
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import AusHome from "@/components/Aushome.vue";
import WPGAHome from "@/components/WPGAhome.vue";
import UpcomingReportSelect from "@/components/UpcomingReportSelect.vue";
import ResultsReportSelect from "@/components/ResultsReportSelect.vue";
import axios from "axios";
export default {
  name: "home", 
  props: ['config'],
  components: { 
    UpcomingReportSelect,
    ResultsReportSelect,
    AusHome,
    WPGAHome,
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    return {
      title: [], //Page Title
      description: [], //Meta Description
      ausTournName: '',
      wpgaTournName: '',
      // AusCode: '1201',
      // WPGACode: '048w',
      AusCode: '1028',
      WPGACode: '3333',
      Ausreports: [],
      Wpgareports: [],
      season: '2025',

    //   Not sure if below code is needed
      homepage: true,
      home: true,
      wphome: [],
      inter: "5",
      pro: "44",
      latestsm: "29",
      latestFull: "8",
      featHome: "true",
      data: [],
      reports: [],
      course: [],
      course_code: [],
      tm_params:[],
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      // tourCode: '',
      tourCode: [],
      NextTournCode: [],
      text: '',
      NewWidgetHeight: '',
      NewMinheight: '',
      NewMaxheight: '',
      activeTab: '',
      scores_available: '',
      showReports: '',
      results_available: '',
      smallListTours: [],
      FullListT: [],
      show: false,
      runData: 'N',
      url: '',
      multi_tourns: '',
      finalFilter: [],
      firstArray: [],
      listFinalAll:[],
      EveryTour: [],
      switch: false,
      code: null,
      playsus: false,
      name: '',
      namecourse: '',
      timediff: '',
      until: '',
      codeRolex: '',
      WPGAnamecourse: '',
      WPGAtimediff: '',
      WPGAuntil: '',
      WPGAcodeRolex: '',
      updateSize: '',
      widgetHeight: '',
      upComingAus: [],
      upComingWPG: [],
      sponsorLogo: '',
      roundPlayed: '',
      nameWomen:'',
      showReport: false,
      MessageTour: ''
    };
  },
  methods: {
    say: function(tourMessage) {
      this.MessageTour = tourMessage,
      console.log("this.MessageTour")
      console.log(this.MessageTour)
    },
    myFunction: function() {
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
      if (this.text == 1400 || this.text > 1401) {
        // this.NewWidgetHeight = '669px!important'
        if (this.mobWidget == 'Y') {
          this.NewWidgetHeight = '300px!important' 
        } else {
          // if (this.multi_tourns == 'Y') {
          //   this.NewWidgetHeight = '570px!important'   
          //   this.NewMinheight = '570px!important'     
          //   this.NewMaxheight = '570px!important'            
          // } else {
          //   this.NewWidgetHeight = '589px!important'     
          //   this.NewMinheight = '589px!important'     
          //   this.NewMaxheight = '589px!important'                      
          // }
            this.NewWidgetHeight = '589px!important'     
            this.NewMinheight = '589px!important'     
            this.NewMaxheight = '589px!important'    
        }
      } else if(this.text == 1400 || this.text == 1397) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1400  && this.text > 1200) {
        // this.NewWidgetHeight = '555px!important'
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1199) {
         if (this.mobWidget == 'Y') {
          // this.NewWidgetHeight = '399px!important' 
          this.NewWidgetHeight = '399px!important' 
        } else {
          this.NewWidgetHeight = '411px!important'
          this.NewMinheight = '411px!important'     
          this.NewMaxheight = '411px!important'  
          this.playsus = true
        }
      } else if(this.text < 1400  && this.text > 1199) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important' 
      }
    },
    getTopLevel : function() {
        axios
        .get(
            'https://api.aus.ocs-software.com/pgaaus/cache/aus/' +
            "tmticx?randomadd=" +
            new Date().getTime()
        )
        .then(response => {
            this.tm_params = response.data;
            this.season = response.data.tm_params.season_code;
            // this.namecourse = response.data.course_city;
            // this.timediff = response.data.time_diff_dec;
            // this.until = response.data.days_away;
            // this.codeRolex = response.data.code;
            this.getAusLevel(),
            this.getWPGALevel()
        })
    },
    getAusLevel : function() {
        axios
        .get(
            process.env.VUE_APP_TIC_BASE +
            'aus/' +
            this.season +
            "/" +
            this.season +
            "-" +
            this.AusCode +
            "-tmticx.json?randomadd=" +
            new Date().getTime()
        )
        .then(response => {
            this.tm_params = response.data;
            this.ausTournName = response.data.short_name;
            this.Ausreports = response.data.reports.reports_entry;
            this.namecourse = response.data.course_city;
            this.timediff = response.data.time_diff_dec;
            this.until = response.data.days_away;
            this.codeRolex = response.data.code;
        })
    },
    getWPGALevel : function() {
        axios
        .get(
            process.env.VUE_APP_TIC_BASE +
            'wpg/' +
            this.season +
            "/" +
            this.season +
            "-" +
            this.WPGACode +
            "-tmticx.json?randomadd=" +
            new Date().getTime()
        )
        .then(response => {
            this.tm_params = response.data;
            this.wpgaTournName = response.data.short_name;
            this.Wpgareports = response.data.reports.reports_entry;
            this.WPGAnamecourse = response.data.course_city;
            this.WPGAtimediff = response.data.time_diff_dec;
            this.WPGAuntil = response.data.days_away;
            this.WPGAcodeRolex = response.data.code;
        })
    }
  },
  mounted() {
    window.addEventListener('resize', this.myFunction);
    this.myFunction();
    this.getTopLevel();
  },
  created() {
    setInterval(
    //   console.log('In Interval 270'),
      this.updateSize, 12000,
    //   console.log('In Interval 272')
    );
  },
};
</script>
<style scoped>
::v-deep li.nav-item.widthSpace {
    width: 50%;
}
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: middle;
  border: 0px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
}
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group > button {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  text-align: left;
}
::v-deep .dropdown-toggle::after {
  text-align: right;
  float: right;
  position: relative;
  top: 10px;
}
::v-deep ul.dropdown-menu.show {
  width: 100%;
}
::v-deep .dropdown-item {
  color: #000!important;
}
option.showNone {
  display: none;
}
.suspendBkColor {
  background-color: blue!important;
}
.suspend {
  position: absolute;
  bottom: 0!important;
  background: red!important;
  width: 100%!important;
  text-align: center;
  color: #fff;
  padding-left: 20px;
  padding-right: 23px;
}
::v-deep option.opt-arrow.showNone {
  display: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}
.RolexSection {
  margin-top: 6px;
}
.colClass {
  padding: 0!important;
}
.LiveScoreMessage {
  position: absolute;
  bottom: 0px;
  background: red;
  width: 93%;
  text-align: center;
  color: #fff;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  padding-left: 20px;
  padding-right: 23px;
}
.mobStyleWid {
  width: 100%!important;
  bottom: 2px!important;
}
.LiveScoreMessage > p {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.TournDrop {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
}
::v-deep li.nav-item.tabsStyle.tabWidth {
  width: 50%;
}
::v-deep .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: transparent;
}
::v-deep .tabone {
  width: 27%;
}
::v-deep .tabtwo {
  width: 40%;
}
::v-deep .tabthree {
  width: 33%;
}
.homeHeight {
  /* height: 669px; */
  /* height: 605px; */
  height: 589px;
}
.HomehomeReport-list {
  border: 1px solid #E6E6E6;
}
::v-deep li.nav-item.tabsStyle {
  /* width: 33%; */
}
::v-deep li.nav-item.tabsStyle > a{
  /* padding-left: 13px!important;
  padding-right: 10px!important; */
}
::v-deep .nav-tabs .nav-link:hover {
  cursor: default;
  background-color: #dfe1e6;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: #00433e !important;
  /* padding-left: 18px;
  padding-right: 20px; */
  padding-left: 0px;
  padding-right: 0px;
  text-align: center;
}
::v-deep .nav-tabs .nav-link.active {
  cursor: default;
  background-color: #fff;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #34caa9 !important;
  /* padding-left: 18px;
  padding-right: 20px; */
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: 0px solid #dee2e6;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #E6E6E6;
  color: #B8B8B8 !important;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  /* padding-left: 18px;
  padding-right: 20px; */
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: 0px solid #dee2e6;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs {
    border-bottom: 0px solid #dee2e6;
}
/* ::v-deep .tabWhite { 
  padding-top: 0em;
  height: 581px;
} */
.home {
  background-color: #fff;
}
.title {
  font-weight: 500;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  color: #000;
  font-size: 23pt;
  margin-top: 1em;
  line-height: 1.1;
  /* letter-spacing: 2px; */
}

.ad {
  padding: 15px 0; 
}

.bottomAdBanner {
  width: 100%;
}
.sections {
  padding: 30px 0;
}
.box {
  display: block;
  top: 0px;
  border-radius: 4px;
  position: relative;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
}

.box:hover {
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
  top: -4px;
  background-color: white;
}
@media only screen and (max-height: 1024px) {
  .homeReport-list {
    /* height: auto !important; */
  }
}

@media only screen and (max-height: 990px) {
  ::v-deep option.opt-arrow.showNone {
    display: block;
    -webkit-appearance: block;
    -moz-appearance: block;
    -o-appearance: block;
    appearance: block;
  }
}
@media only screen and (min-height: 501px) {
  .homeContainer.container {
    padding-left: 0px!important;
    padding-right: 0px!important;
  }
  ::v-deep option.opt-arrow.showNone {
    display: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
  }
}
@media only screen and (max-height: 500px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
@media only screen and (max-height: 430px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
.mobWidgetPad {
  height: 476px!important;
}
@media only screen and (max-width: 550px) {
  ::v-deep li.nav-item.widthSpace > a{
    font-size: 12px
  }
  ::v-deep li.nav-item.widthSpace > a:hover{
    font-size: 12px
  }
}
@media only screen and (max-width: 480px) {
  .bottomAdBanner{
    padding: 15px 0;
  }
  .hero-plus__html-content iframe {
    width: 94%!important;
    height: 980px!important;
  }
  ::v-deep li.nav-item.widthSpace > a {
    font-size: 12px;
  }
  ::v-deep li.nav-item.widthSpace > a:hover {
    font-size: 12px;
  }
}

@media only screen and (max-width: 419px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    color: #34caa9 !important;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
  }
}

@media only screen and (max-width: 400px) {
  
  ::v-deep li.nav-item.widthSpace > a:hover{
    height: 28px;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    white-space: nowrap;
    /* width: 50px; */
    overflow: hidden;
    text-overflow: "----";
  }
  ::v-deep li.nav-item.widthSpace > a{
    height: 28px;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    white-space: nowrap;
    /* width: 50px; */
    overflow: hidden;
    text-overflow: "----";
  }
  ::v-deep option.hideMobNow {
    display: none!important;
  }
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px!important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px!important;
    color: #00433e !important;
    padding-left: 18px;
    padding-right: 20px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}

@media only screen and (max-width: 375px) {
    ::v-deep li.nav-item.widthSpace > a:hover {
        font-size: 10px !important;
    }
    ::v-deep li.nav-item.widthSpace > a {
      font-size: 10px!important;
    }
    ::v-deep li.nav-item.widthSpace > a:hover {
        height: 38px;
    }
    ::v-deep li.nav-item.widthSpace > a {
        height: 38px;
    }
}
@media only screen and (max-width: 321px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 10px;
    padding-right: 15px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 375px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
